import React from 'react';
import Header from '../components/Header';
import '../styles/theme.css';

const Settings = () => {
  return (
    <div className="max-w-7xl">
      <Header title="Settings" />
      
      <div className="space-y-6">
        {/* Account Settings */}
        <div className="card p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4">👤 Account Settings</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Display Name
              </label>
              <input
                type="text"
                placeholder="Your name"
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                disabled
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <input
                type="email"
                placeholder="your@email.com"
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                disabled
              />
            </div>
            <p className="text-sm text-gray-500">
              ⚠️ Settings functionality coming soon
            </p>
          </div>
        </div>

        {/* Notification Settings */}
        <div className="card p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4">🔔 Notifications</h2>
          <div className="space-y-3">
            <label className="flex items-center space-x-3">
              <input type="checkbox" className="rounded" disabled />
              <span className="text-gray-700">Email notifications for new reviews</span>
            </label>
            <label className="flex items-center space-x-3">
              <input type="checkbox" className="rounded" disabled />
              <span className="text-gray-700">Daily summary reports</span>
            </label>
            <label className="flex items-center space-x-3">
              <input type="checkbox" className="rounded" disabled />
              <span className="text-gray-700">Weekly analytics digest</span>
            </label>
            <p className="text-sm text-gray-500 mt-4">
              ⚠️ Settings functionality coming soon
            </p>
          </div>
        </div>

        {/* API Settings */}
        <div className="card p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4">🔑 API Integration</h2>
          <p className="text-gray-600 mb-4">
            Manage your Google Business API connection
          </p>
          <button className="btn-gradient-blue" disabled>
            Reconnect Google Account
          </button>
          <p className="text-sm text-gray-500 mt-4">
            ⚠️ Settings functionality coming soon
          </p>
        </div>
      </div>
    </div>
  );
};

export default Settings;
